<template>
  <div id="stashboard" :class="{loading: loading}">
    <div v-if="error" class="error">{{ error }}</div>
    <div v-if="loading" class="loading">
      <img :src="loadingGif" alt="loading"/>
    </div>
    <template v-else>
      <div class="row">
        <div class="title">
          {{ merchantNameDecoded }}
        </div>
        <div v-if="urlLogo" class="logo">
          <img :src="urlLogo" alt="logo" />
        </div>
      </div>
      <div class="content">
        <a v-if="urlImage" :href="urlImage" target="_blank" class="ads">
          <img :src="urlImage" alt="image" />
        </a>
        <div class="body">
          <div class="formatted-content" v-html="formattedContent"></div>
          <template v-if="extensionType === 'any_link'">
            <div class="anylinks">
              <a v-if="anyLinks.length > 1" @click="seeButton = !seeButton" class="see-button">
                <template v-if="seeButton">see less</template>
                <template v-else>see all</template>
              </a>
              <div class="links-wrapper" :class="{ inline: !seeButton && anyLinks.length > 1}">
                <div class="links">
                  <a :href="link.url" target="_blank" class="link" v-for="(link, index) in anyLinks" :key="index">
                    <div class="link-icon">
                      <svg viewBox="0 0 512.092 512.092">
                        <use xlink:href="#link-icon"></use>
                      </svg>
                    </div>
                    <img :src="link.thumbnail ? link.thumbnail.url + '?h=100&w=150' : defaultThumbnailImage" :alt="link.title" class="link-img" />
                    <div class="link-detail">
                      <span class="link-title">{{ link.title }}</span>
                      <span class="link-url">{{ link.url }}</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <a v-if="labelButton" :href="urlButton ? urlButton : merchantWebsiteUrl"  class="link-button" target="_self">{{ labelButton }}</a>
          </template>
          <div class="links-wrapper">            
            <div v-if="appStoreUrl" class="app-store-div">
              <a :href="appStoreUrl" target="_blank">
                <img :src="appStoreImage" alt="image" class="app-store-img" />
              </a>
            </div>                        
            <div v-if="googlePlayUrl" class="app-store-div">
              <a :href="googlePlayUrl" target="_blank">
                <img :src="playStoreImage" alt="image" class="app-store-img" />
              </a>
            </div>            
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import linkifyHtml from 'linkifyjs/html'
  import loadingGif from 'passcode/loading.gif'
  import defaultThumbnailImage from 'stashboard/default_thumbnail_image.png';
  import appStoreImage from 'stashboard/download-on-the-app-store.png';
  import playStoreImage from 'stashboard/get-it-on-google-play.png';

  export default {
    props: {
      anyLinks: Array,
      id: String,
      content: String,
      extensionType: String,
      merchantName: String,
      merchantWebsiteUrl: String,
      urlButton: String,
      urlImage: String,
      urlLogo: String,
      appStoreUrl: String,
      googlePlayUrl: String,
    },

    name: "Stashboard",

    data() {
      return {
        defaultThumbnailImage,
        loading: false,
        loadingGif,
        error: null,
        seeButton: false,
        appStoreImage,
        playStoreImage,
      }
    },

    created(){
      /* BEGIN */
      /* This is a temporary solution for old campaign */
      /* Old campaign that does not have sms_content or extensions */
      /* This code will be removed later on */
      if(!this.extensionType & !this.content & !!this.urlButton) {
        this.loading = true
        location.replace(this.urlButton)
      }
      /* END */
      if(!this.merchantName){
        this.loading = true
        location.replace(`/passcode/${this.id}`)
      }
    },

    computed: {
      formattedContent(){
        const options = {
                nl2br: true
              },
              content = this.content

        return (content) ? linkifyHtml(content, options) : ""
      },

      labelButton(){
        const type = this.extensionType
        let label = ""

        if(type == "target_wallet") label = "view wallet"
        else if(!type && this.merchantWebsiteUrl) label = "shop online"
        else if(!!type) label = "view offer"

        return label
      },

      merchantNameDecoded(){
        return this.merchantName ? atob(this.merchantName) : ""
      }
    }
  }
</script>
